
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"5.506","height":"8.806"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Path_1049","data-name":"Path 1049","fill":"none"}},[_c('path',{attrs:{"d":"M-163.646 223.429l-.509-1.868a.824.824 0 00-.657-.594 1.037 1.037 0 00-.232-.012l-.213-2.128h.549a.272.272 0 00.274-.272.273.273 0 00-.273-.273h-3.355a.274.274 0 00-.274.272.274.274 0 00.273.273h.55l-.213 2.128h-.1a.831.831 0 00-.232.033.829.829 0 00-.565.573l-.509 1.868a.274.274 0 00.142.316 4.705 4.705 0 002.068.607v1.82l.533.915.552-.915v-1.814a4.622 4.622 0 002.047-.607.272.272 0 00.144-.322z","transform":"translate(169.141 -218.28)"}}),_c('path',{attrs:{"d":"M-166.312 223.38l.422-.021c.397-.021.746-.096 1.12-.248l-.313-1.152-.86.052-.274-2.731h-.337l-.268 2.675h-.872l-.312 1.148c.385.156.733.23 1.134.25l.56.027m-.077 3.706l-.533-.915v-1.82c-.77-.038-1.385-.246-2.068-.606a.274.274 0 01-.142-.316l.51-1.868a.829.829 0 01.797-.606h.098l.213-2.128h-.55a.274.274 0 01-.273-.273v-.002a.274.274 0 01.275-.272h3.355c.15 0 .273.122.273.273v.002a.273.273 0 01-.274.272h-.549l.213 2.128c.078-.004.156 0 .232.012a.824.824 0 01.657.594l.509 1.868a.272.272 0 01-.144.321c-.667.36-1.29.568-2.048.607v1.814l-.551.915z","fill":"#6b7786","transform":"translate(169.141 -218.28)"}})])])
          )
        }
      }
    